import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { toast } from 'react-toastify';

import { 
  TemplateToolbar, 
  TemplateTable, 
  RegAndEditAdvertise, 
  PreviewDialog 
} from './components';

import { PageTitle, SimplePopup } from 'components';

// >> redux
import {
  getAdvertises,
  addAdvertise,
  updateAdvertise,
  deleteAdvertises,
  findAdvertises,
  removeAdvertises
} from 'redux/actions/advertises';
// <<


// >> redux
import {
  getAgencies,
  getClients,
} from 'redux/actions/companies';
// <<


// >> redux
import {
  getAddresses,
  findAddresses,
  getPositionToAddress,
} from 'redux/actions/addresses';
// <<

import { IsNoU, adCheckStatus } from 'common/utils';


//import { agencies, clients } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
}));

const Template = (props) => {
  
  const classes = useStyles();

  const { template, category } = props.match.params;

  const { 
    advertises,
    advertise_total, 
    loading, 
    loadingClient, 
    loadingFind, 
    loadingPage, 
    agencies, 
    clients,
//    addresses,
    finded_addresses,
    position_to_address,
    loadingAddresses,
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [openRegAndEditDialog, setOpenRegAndEditDialog] = useState(false);
  const [modeRegisterDlg, setModeRegisterDlg] = useState(true);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [openPreviewDlg, setOpenPreviewDlg] = useState(false);

  const [editAdvertise, setEditAdvertise] = useState(null);

  const [selectedAgency, setSelectedAgency] = useState('');
  const [selectedClient, setSelectedClient] = useState('');

  const [selectedAdvertises, setSelectedAdvertises] = useState([]);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [selectedPreviewName, setSelectedPreviewName] = useState('');
  const [selectedPreviewMovie, setSelectedPreviewMovie] = useState('');
  const [selectedPreviewImage, setSelectedPreviewImage] = useState('');

  //const [findAdvertises, setFindAdvertises] = useState([]);

  //const [openProgress, setOpenProgress] = useState(false);

  const [address_type, set_address_type] = useState([]);
  const [address_sidoes, set_address_sidoes] = useState([]);
  const [address_guguns, set_address_guguns] = useState([]);
//  const [address_dongs, set_address_dongs] = useState([]);
  const [address_roades, set_address_roades] = useState([]);
  const [address_building_numbers, set_address_building_numbers] = useState([]);
  const [address_building_names, set_address_building_names] = useState([]);

  const [find_data, set_find_data] = useState({});
  
  const handleFindItem = (name, agency, client) => {

    // if (IsNoU(name) || name.length <= 0)
    //   name = 'all';
    // if (IsNoU(agency) || agency.length <= 0)
    //   agency = 'all';
    // if (IsNoU(client) || client.length <= 0)
    //   client = 'all';

    //console.log(name + agency + client);
    
    // const findItems = advertises.filter((advertise) => {
    //   // console.log(advertise);
    //   // console.log(advertise.name.indexOf(name));
    //   // console.log(advertise.agency.indexOf(agency));
    //   // console.log(advertise.client.indexOf(client));
    //   return (name === 'all' || advertise.name.indexOf(name) !== -1)
    //     && (agency === '전체' || advertise.agency.indexOf(agency) !== -1)
    //     && (client === '전체' || advertise.client.indexOf(client) !== -1) ;
    // });

    //console.log(findItems);

    //setFindAdvertises(findItems);

    let ad_name = '';
    let ad_agency = '';
    let ad_client = '';
    if (name.length > 0)
      ad_name = name;
    if (agency !== '전체')
      ad_agency = agency;
    if (client !== '전체')
      ad_client = client;

    setPage(0);

    let find_data = {
      template: template,
      category: category, 
      name: ad_name,
      agency: ad_agency,
      client: ad_client,
      page: page,
      rows_per_page: rowsPerPage,
    };
    set_find_data(find_data);

    props.findAdvertises(find_data);
  }

  const handleClickOpenRegisterDialog = () => {

    if (IsNoU(agencies) || agencies.length <= 0) {
      toast("광고대행사 사항이 없습니다.\n 광고대행사를 먼저 입력하세요.");
      return ;
    }

    if (IsNoU(clients) || clients.length <= 0) {
      toast("광고주 사항이 없습니다.\n 광고사를 먼저 입력하세요.");
      return ;
    }

    setEditAdvertise(null);
    setModeRegisterDlg(true);

    setOpenRegAndEditDialog(true);
  };

  const handleClickOpenEditDialog = () => {

    if (selectedAdvertises.length !== 1){
      return ;
    }
    const id = selectedAdvertises[0];
    const selectedAdvertise = advertises.find(advertise => (advertise.id === id));

    //console.log(selectedAdvertise);
    setEditAdvertise(selectedAdvertise);
    setModeRegisterDlg(false);

    if (template === 'welcome' && !IsNoU(selectedAdvertise.welcome)) {
      const addresses = selectedAdvertise.welcome.split(',');
      if (addresses.length > 1) {
        set_address_guguns([addresses[1]]);
      }
    }

    setOpenRegAndEditDialog(true);
  };

  const handleClickCloseRegAndEditDialog = () => {
    setOpenRegAndEditDialog(false);
  };

  const handleClickSaveAdvertise = (advertise) => {

    if (modeRegisterDlg) 
    {
      props.addAdvertise(template, category, advertise);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterDlg && selectedAdvertises.length === 1)
    {
      const id = selectedAdvertises[0];
      props.updateAdvertise(template, category, id, advertise);
    }
    else
    {
      
    }

    setOpenRegAndEditDialog(false);
  };

  const handleSetSelectedAdvertises = (checks) => {
    setSelectedAdvertises(checks);
  }

  const [agencyClients, setAgencyClients] = useState([]);
  const handleChangeAgency = e => {
    let newAgencyClients = clients.filter(client => client.agency === e.target.value);
    //console.log('new agency clients ->');
    //console.log(newAgencyClients);
    setAgencyClients(newAgencyClients);
    setSelectedClient('');
    setSelectedAgency(e.target.value);
  };

  const handleChangeClient = event => {
    setSelectedClient(event.target.value);
  };

  const handleClickOpenDeleteAlert = () => {
    if (selectedAdvertises.length === 0){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    //console.log('handleClickDeleteAlertOk -> ' + selectedTemplates.length);
    if (selectedAdvertises.length === 0){
      return ;
    }

    const deletes = selectedAdvertises.map((selected)=>{
      return advertises.find(advertise => (advertise.id === selected));
    });

    props.deleteAdvertises(template, deletes);

    // let deleteItems = deletes.filter(advertise => adCheckStatus(advertise) === 'danger');
    // //console.log(deleteItems);
    // //setDisableDeleteButton(deleteItems.length < 1);

    // //console.log('handleClickDeleteAlertOk -> ' + type + ',' + deletes);

    // props.deleteAdvertises(template, deleteItems);

    setOpenDeleteAlert(false);
  }

  const handleClickPreview = (advertise) => {
    //setSelectedPreviewTemplate(template);
    //console.log(advertise);
    setSelectedPreviewName(advertise.name);
    setSelectedPreviewMovie(advertise.movie);
    setSelectedPreviewImage(advertise.image);
    setOpenPreviewDlg(true);
  }

  const handleClickClosePreviewDlg = () => {
    setOpenPreviewDlg(false);
  }

  const handleRefreshAddressSelect = () => {
    set_address_type('sido');
    props.findAddresses({type: 'sido'});

    set_address_sidoes([]);
    set_address_guguns([]);
//    set_address_dongs([]);
    set_address_roades([]);
    set_address_building_numbers([]);
    set_address_building_names([]);
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    let page_find_data = {
      template: find_data.template,
      category: find_data.category, 
      name: find_data.ad_name,
      agency: find_data.ad_agency,
      client: find_data.ad_client,
      page: page,
      rows_per_page: rowsPerPage,
    };
    //console.log(page_find_data);
    props.findAdvertises(page_find_data);
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);
    let page_find_data = {
      template: find_data.template,
      category: find_data.category, 
      name: find_data.ad_name,
      agency: find_data.ad_agency,
      client: find_data.ad_client,
      page: page,
      rows_per_page: rows_per_page,
    };
    //console.log(page_find_data);
    props.findAdvertises(page_find_data);
  };

  useEffect(() => {
    //console.log("componentDidMount");
    props.getAgencies();
    props.getClients();
    //props.getAdvertises(template, category);

    if (template === 'position' || template === 'welcome') {
      set_address_type('sido');
      //props.getAddresses('sido');
      props.findAddresses({type: 'sido'});
    }

    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    return () => {
      //console.log("componentDidUnmount");
      props.removeAdvertises();
    };
  }, []); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   console.log("componentDidUpdate & template changed");
  //   //props.getAdvertises(template, category);
  // }, [template]); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log("componentDidUpdate & category changed");
    //props.getAdvertises(template, category);
    props.removeAdvertises();
    setPage(0);
  }, [category]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   //console.log("componentDidUpdate & advertises changed");
  //   if (!IsNoU(advertises) && advertises.length > 0) {
  //     setFindAdvertises(advertises);
  //   }
  //   else {
  //     setFindAdvertises([]);
  //   }
  // }, [advertises]); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditButton(selectedAdvertises.length != 1);
    setDisableDeleteButton(selectedAdvertises.length < 1);

    // const deletes = selectedAdvertises.map((selected)=>{
    //   return advertises.find(advertise => (advertise.id === selected));
    // });

    // let deleteItems = deletes.filter(advertise => adCheckStatus(advertise) === 'danger');
    // //console.log(deleteItems);
    // setDisableDeleteButton(deleteItems.length < 1);

  }, [selectedAdvertises]);


  /**
   * 주소 요청.
   */
   //const handleSelectedAddress = (type, selectedSido, selectedGugun, selectedDong, selectedRoad, selectedBuildingNumber) => {
  const handleSelectedAddress = (type, selectedSido, selectedGugun, selectedRoad, selectedBuildingNumber) => {
    set_address_type(type);
    //props.findAddresses({type:type, sido:selectedSido, gugun:selectedGugun, dong:selectedDong, road:selectedRoad, building_number: selectedBuildingNumber});
    props.findAddresses({type:type, sido:selectedSido, gugun:selectedGugun, road:selectedRoad, building_number: selectedBuildingNumber});
  }

  useEffect(() => {
    console.log('find address ->' + address_type);
    console.log(finded_addresses);
    //props.getAddresses('sido');
    if (address_type === 'sido') {
      set_address_sidoes(finded_addresses);
    }
    else if (address_type === 'gugun') {
      set_address_guguns(finded_addresses);
    }
    // else if (address_type === 'dong') {
    //   set_address_dongs(finded_addresses);
    // }
    else if (address_type === 'road') {
      set_address_roades(finded_addresses);
    }
    else if (address_type === 'building_number') {
      set_address_building_numbers(finded_addresses);
    }
  }, [finded_addresses]);

  useEffect(()=> {
    if (!IsNoU(position_to_address)) {
      if (!IsNoU(position_to_address.gugun)) set_address_guguns([position_to_address.gugun])
      //if (!IsNoU(position_to_address.dong)) set_address_dongs([position_to_address.dong])
      if (!IsNoU(position_to_address.road)) set_address_roades([position_to_address.road])
      if (!IsNoU(position_to_address.building_number)) set_address_building_numbers([position_to_address.building_number])
    }
  }, [position_to_address]);

  if (loading || loadingClient) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      {template !== 'default' &&
       template !== 'normal' &&
       template !== 'free' &&
       template !== 'image' &&
       template !== 'top' &&
       template !== 'position' && 
       template !== 'welcome' && <Redirect to="/not-found"/>}

      <PageTitle 
        pageTitle={category}
      />

      <TemplateToolbar 
        template={template}
        category={category}
        onClickFind={handleFindItem}
        agencies={[{id:-1, name: '전체'}, ...agencies]}
        clients={[{id:-1, name: '전체'}, ...agencyClients]}
        selectedAgency={selectedAgency}
        onChangeAgency={handleChangeAgency}
        selectedClient={selectedClient}
        //onSetSelectedClient={client => setSelectedClient(client)}
        onChangeClient={handleChangeClient}
        />

      <div className={classes.content}>
        <TemplateTable 
          userRole={userRole}

          advertises={advertises} 
          onSetSelectedAdvertises={handleSetSelectedAdvertises}
          onClickPreview={handleClickPreview}
          
          onClickOpenRegisterDialog={handleClickOpenRegisterDialog}
          onClickOpenEditDialog={handleClickOpenEditDialog}
          onClickOpenDeleteDialog={handleClickOpenDeleteAlert}
          disableEditButton={disableEditButton}
          disableDeleteButton={disableDeleteButton}

          openProgress={loadingFind}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={advertise_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          />
      </div>


      <RegAndEditAdvertise 
        openDialog={openRegAndEditDialog} 
        onClickCloseDialog = {handleClickCloseRegAndEditDialog}
        onClickSaveDialog = {handleClickSaveAdvertise}
        editAdvertise = {editAdvertise}
        modeRegisterDlg = {modeRegisterDlg}

        userName = {modeRegisterDlg ? userName : ''}

        template={template}
        category={category}

        agencies={agencies}
        clients={clients}

        onSelectedAddress = {handleSelectedAddress}
        //addresses={addresses}
        address_sidoes={address_sidoes}
        address_guguns={address_guguns}
//        address_dongs={address_dongs}
        address_roades={address_roades}
        address_building_numbers={address_building_numbers}
        address_building_names={address_building_names}
        refresh_addresses={handleRefreshAddressSelect}
        
        getPositionToAddress = {(xpos, ypos) => {props.getPositionToAddress({xpos,ypos})}}
        position_to_address = {position_to_address}

        loading_address = {loadingAddresses}
        />
      {/* {console.log(`/CMS/${props.advertiseMoviePath}/${selectedPreviewMovie}`)} */}
      <PreviewDialog 
        openDialog={openPreviewDlg} 
        onClickCloseDialog={handleClickClosePreviewDlg}
        template = {template}
        advertiseName={selectedPreviewName}
        advertiseMovieURL={
          template === 'image' ? '' :
          `/CMS/${props.advertiseMoviePath}/${selectedPreviewMovie}`
        }
        advertiseMovie={selectedPreviewMovie}
        advertiseImageURL={`/CMS/${props.advertiseMoviePath}/${selectedPreviewImage}`}
        advertiseImage={selectedPreviewImage}
        //advertiseURL={`/CMS/${props.advertiseMoviePath}/${selectedPreviewMovie}`}
        />

      <SimplePopup
        title={`광고를 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />

    </div>
  );
};



Template.propTypes = {
  loading: PropTypes.bool,
  advertises: PropTypes.arrayOf(PropTypes.object),

  agencies: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),

  addresses: PropTypes.arrayOf(PropTypes.object),
  finded_addresses: PropTypes.arrayOf(PropTypes.string),
};

Template.defaultProps = {
  loading: false,
  loadingClient: false,
  loadingFind: false,
  loadingPage: false,

  loadingAddress: false,

  advertises: [],

  agencies: [],
  clients: [],

  addresses: [],
  finded_addresses: [],
  position_to_address: {},
};

const mapStateToProps = state => ({
  loading: state.advertises.loading || state.companies.loading,// || state.addresses.loading,
  loadingClient: state.companies.loading,
  loadingFind: state.advertises.find_loading,

  loadingAddresses: state.addresses.loading,

  advertiseMoviePath: state.advertises.advertiseMoviePath,
  advertise_total: state.advertises.advertiseTotal,
  advertises: state.advertises.advertiseList,

  agencies: state.companies.reged_agencyList,
  clients: state.companies.reged_clientList,
  addresses: state.addresses.addressList,

  finded_addresses: state.addresses.findList,
  position_to_address: state.addresses.position_to_address,
});

const mapDispatchToProps = dispatch => ({
  getAdvertises: (template, category) => {getAdvertises(template, category, dispatch)},
  addAdvertise: (template, category, advertise) => {addAdvertise(template, category, advertise, dispatch)},
  updateAdvertise: (template, category, id, advertise) => {updateAdvertise(template, category, id, advertise, dispatch)},
  deleteAdvertises: (template, deletes) => {deleteAdvertises(template, deletes, dispatch)},

  findAdvertises: (find) => {findAdvertises(find, dispatch)},
  removeAdvertises: () => {removeAdvertises(dispatch)},

  getAgencies: () => {getAgencies(dispatch)},
  getClients: () => {getClients(dispatch)},

  getAddresses: (type) => {getAddresses(type, dispatch)},
  findAddresses: (find) => {findAddresses(find, dispatch)},
  getPositionToAddress: (position) => {getPositionToAddress(position, dispatch)}
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Template);
//export default AdvertiseDefaultTemplate;
